// homepage/hompage-widget/headcount-widget/headcount-widget.component.ts
import { Component, OnInit } from '@angular/core';
import { ChartModule } from 'primeng/chart';

import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core'; 

import { PeoplesService } from '../../../services/peoples.service';
import { IHeadcountStatistic } from '../../../_interfaces/headCountStatistic';

@Component({
  selector: 'app-headcount-widget',
  standalone: true,
  imports: [
    ChartModule,
    TranslatePipe,
    TranslateModule
],
  templateUrl: './headcount-widget.component.html',
  styleUrl: './headcount-widget.component.scss'
})
export class HeadcountWidgetComponent implements OnInit {

  headcountData: IHeadcountStatistic[] = [];
  chartData: any; // Données formatées pour PrimeNG Chart
  chartOptions: any; // Options de configuration pour PrimeNG Chart

  isLoading: boolean = true; // Pour l'état de chargement
  errorMessage: string | null = null; // Pour les messages d'erreur

  constructor(private peoplesService: PeoplesService, private translateService: TranslateService) { }

  ngOnInit(): void {
    this.isLoading = true; // Début du chargement
    this.errorMessage = null; // Réinitialiser tout message d'erreur

    this.peoplesService.getHeadcountStatistics().subscribe({
      next: (data) => {
        this.headcountData = data;
        if (this.headcountData && this.headcountData.length > 0) {
          this.prepareChartData();
        } else {
          this.errorMessage = 'COMMON.NO_DATA_AVAILABLE'; // Utilisez une clé de traduction si vous avez des messages génériques
          console.warn('Aucune donnée d\'effectifs reçue.');
        }
        this.isLoading = false; // Fin du chargement
      },
      error: (err) => {
        console.error('Erreur lors du chargement des statistiques d\'effectifs :', err);
        
        this.translateService.get('DASHBOARD.ERRORS.ERROR_LOADING_DATA').subscribe((translatedMessage: string) => {
          this.errorMessage = translatedMessage;
        });
        
        this.isLoading = false; // Fin du chargement même en cas d'erreur
      }
    });
  }

  prepareChartData(): void {
    // Si la méthode est appelée sans données, on sort.
    if (!this.headcountData || this.headcountData.length === 0) {
      this.chartData = null;
      return;
    }

    const labels = this.headcountData.map(item => item.month);
    const totalHeadcountValues = this.headcountData.map(item => item.totalHeadcount);

    const maxHeadcount = Math.max(...totalHeadcountValues);
    const topMargin = maxHeadcount * 0.15; // Ajout de 15% de marge au-dessus
    const maxChartOption = Math.ceil(maxHeadcount + topMargin);

    const translatedLabel = this.translateService.instant('DASHBOARD.HEADCOUNT_WIDGET.TOTAL_HEADCOUNT_LABEL');

    this.chartData = {
      labels: labels,
      datasets: [
        {
          label: translatedLabel,
          data: totalHeadcountValues,
          fill: false,
          borderColor: '#42A5F5',
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 5,
          pointHitRadius: 10
        }
      ]
    };

    this.chartOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.8, // Peut être ajusté ou retiré si la taille est gérée par le CSS
      plugins: {
       legend: {
          display: false, 
        },
         datalabels: {
          display: false 
        },
        // tooltip: {
        //     backgroundColor: 'rgba(0,0,0,0.7)',
        //     titleColor: '#ffffff',
        //     bodyColor: '#ffffff',
        //     footerColor: '#ffffff'
        // }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: { display: false }
        },
        y: {
          ticks: {color: '#495057',},
          grid: {display:false},
          min: 0,
          max:maxChartOption
        }
      }
    };
  }
}